import React, { createContext, useContext, useMemo, useState } from 'react';

type BottomPanelInsetContextValue = {
    /** Pixels to reserve at the bottom of the viewport (terminal height when open). */
    insetPx: number;
    setInsetPx: (px: number) => void;
};

const BottomPanelInsetContext = createContext<BottomPanelInsetContextValue | null>(null);

export function BottomPanelInsetProvider({ children }: { children: React.ReactNode }) {
    const [insetPx, setInsetPx] = useState(0);
    const value = useMemo(() => ({ insetPx, setInsetPx }), [insetPx]);
    return (
        <BottomPanelInsetContext.Provider value={value}>{children}</BottomPanelInsetContext.Provider>
    );
}

export function useBottomPanelInset(): BottomPanelInsetContextValue {
    const ctx = useContext(BottomPanelInsetContext);
    if (!ctx) {
        return { insetPx: 0, setInsetPx: () => {} };
    }
    return ctx;
}
